import { ColorOptions } from '@mui/material/styles';

export const getPieColors = (palettes: ColorOptions[]) => {
  return {
    backgroundColor: palettes.map((color) => color[200]),
    hoverBackgroundColor: palettes.map((color) => color[300]),
    borderColor: palettes.map((color) => color[500]),
  };
};
